import { all, fork, put } from 'redux-saga/effects';
import { userSaga, fileSaga, init } from '@centerpiece/components';
// import { itemSaga } from 'store/api';

export function* rootSaga() {
  yield all([
    fork(userSaga),
    fork(fileSaga),
    // fork(itemSaga)
  ]);
  yield put(init());
}
